export default "__VITE_ASSET__4e9190f6__"